import { render, staticRenderFns } from "./SearchNews.vue?vue&type=template&id=1c7d3da2&scoped=true"
import script from "./SearchNews.vue?vue&type=script&lang=js"
export * from "./SearchNews.vue?vue&type=script&lang=js"
import style0 from "./SearchNews.vue?vue&type=style&index=0&id=1c7d3da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7d3da2",
  null
  
)

export default component.exports